/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { array, string } from 'prop-types';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
    section: { background: '#f5f5f5', padding: '55px 24px 60px', color: '#111', textAlign: 'center', '@media (max-width: 600px)': { padding: '36px 20px 42px' } },
    panel: { boxSizing: 'border-box', maxWidth: 1000, minHeight: 450, margin: '0 auto', padding: '90px 30px 45px', background: '#fff', '@media (max-width: 600px)': { minHeight: 360, padding: '55px 22px 36px' } },
    heading: { maxWidth: 320, margin: '0 auto 40px', fontSize: 23, lineHeight: 1.05, fontWeight: 700, '@media (max-width: 600px)': { fontSize: 20, marginBottom: 30 } },
    stars: { color: '#D9AC40', fontSize: 27, letterSpacing: 4, lineHeight: 1 },
    review: { maxWidth: 430, margin: '13px auto 0' },
    quote: { fontSize: 20, lineHeight: 1.2, fontStyle: 'italic', margin: '0 auto 8px', '@media (max-width: 600px)': { fontSize: 17 } },
    name: { fontSize: 19, fontWeight: 700, margin: 0 },
    dots: { display: 'flex', justifyContent: 'center', gap: 9, marginTop: 25 },
    dot: { width: 9, height: 9, borderRadius: '50%', border: 0, background: '#d5d5d5', padding: 0, cursor: 'pointer' },
    activeDot: { background: '#111' },
}));

const PassportLanderReviews = ({ heading, reviews }) => {
    const classes = useStyles();
    const [activeIndex, setActiveIndex] = useState(0);
    const review = reviews[activeIndex];
    return (
        <section className={classes.section} data-component="passportLanderReviews" aria-label="Member reviews">
            <div className={classes.panel}>
                <h2 className={classes.heading}>{heading}</h2>
                <div className={classes.stars} aria-label="Five stars">★★★★★</div>
                <article className={classes.review} aria-live="polite">
                    <p className={classes.quote}>“{review?.user_review}”</p>
                    <p className={classes.name}>~ {review?.user_name}</p>
                </article>
                {reviews.length > 1 && (
                    <div className={classes.dots}>
                        {reviews.map((item, index) => (
                            <button
                                type="button"
                                key={item?._metadata?.uid || index}
                                className={activeIndex === index ? `${classes.dot} ${classes.activeDot}` : classes.dot}
                                onClick={() => setActiveIndex(index)}
                                aria-label={`Show review ${index + 1}`}
                                aria-current={activeIndex === index ? 'true' : undefined}
                            />
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};
PassportLanderReviews.propTypes = { heading: string, reviews: array.isRequired };
PassportLanderReviews.defaultProps = { heading: 'Member reviews' };
export default PassportLanderReviews;
